import { format, unwrapFunctionStore } from 'svelte-i18n';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const managingFields = {
  element: '.fields-heading',
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.FIELDS.MANAGING_FIELDS.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.FIELDS.MANAGING_FIELDS.DESCRIPTION'),
    side: 'top',
    align: 'start',
    onPrevClick: () => {
      const editHtmlButton = document.querySelector(
        '#signature-editor > div.page-content > div > div.editor-left-pane > div:nth-child(2) > div > div > button'
      );

      if (editHtmlButton) {
        editHtmlButton.click();

        setTimeout(() => {
          GLOBAL_DRIVER_OBJECT.movePrevious();
        }, 50);
      }
    }
  }
};

export const addingField = {
  element: '#signature-editor > div.page-content > div > div.editor-right-pane > div > button',
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.FIELDS.ADDING_FIELD.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.FIELDS.ADDING_FIELD.DESCRIPTION'),
    side: 'top',
    align: 'start'
  }
};

export const removingField = {
  element:
    '#signature-editor > div.page-content > div > div.editor-right-pane > div > div.signature-fields > div:nth-child(2) > div > i.os-icon-x',
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.FIELDS.REMOVING_FIELD.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.FIELDS.REMOVING_FIELD.DESCRIPTION'),
    side: 'top',
    align: 'start'
  }
};

export const hidingField = {
  element:
    '#signature-editor > div.page-content > div > div.editor-right-pane > div > div.signature-fields > div:nth-child(2) > div > input:nth-child(2)',
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.FIELDS.HIDING_FIELD.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.FIELDS.HIDING_FIELD.DESCRIPTION'),
    side: 'top',
    align: 'start'
  }
};

export const reorderingField = {
  element:
    '#signature-editor > div.page-content > div > div.editor-right-pane > div > div.signature-fields > div:nth-child(2) > div > i.os-icon-drag',
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.FIELDS.REORDERING_FIELD.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.FIELDS.REORDERING_FIELD.DESCRIPTION'),
    side: 'top',
    align: 'start'
  }
};
